/**
 * CountrySelect — drop-in replacement for `<input placeholder="Pays">`.
 * Renders a select with flag emojis and emits both the country name and the
 * default language tied to that country (FR/EN/ES/IT/PT). Use the `onChange`
 * (value-only) for backward compat, or `onSelect({name, code, lang})` for full info.
 */
import { COUNTRIES, findCountry } from "@/lib/countries";

export default function CountrySelect({
  value,
  onChange,
  onSelect,
  className = "",
  placeholder = "— Choisir un pays —",
  testId,
  required = false,
}) {
  const handle = (e) => {
    const name = e.target.value;
    const entry = findCountry(name);
    onChange?.(name);
    onSelect?.({
      name,
      code: entry?.code || null,
      lang: entry?.lang || "fr",
      flag: entry?.flag || "",
    });
  };
  return (
    <select
      value={value || ""}
      onChange={handle}
      required={required}
      className={`rounded-xl border border-neutral-200 bg-white px-3 py-2 text-sm focus:border-wine-400 focus:outline-none ${className}`}
      data-testid={testId || "country-select"}
    >
      <option value="">{placeholder}</option>
      {COUNTRIES.map((c) => (
        <option key={c.code} value={c.name}>{`${c.flag}  ${c.name}`}</option>
      ))}
    </select>
  );
}
